module.exports = __webpack_public_path__ + "img/mono_10.44e2d07c.png";